module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Pat Wyeth-af6632bc3778cf6957e8e2a1e7b17382.jpg";